import React, { useEffect, useState } from 'react'

import {
  Badge, Table, Spin, Divider, PageHeader, Row, Col,
} from 'antd'

import { format } from 'date-fns'

import { fetch } from '../../utils/fetch'

import LogJobFilter from './component/LogJobFilter'

const { Column } = Table

const LogJob = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [logJobData, setLogJobData] = useState([])

  const getLogJob = (query) => {
    setIsLoading(true)
    fetch({
      url: '/systemLogging/job',
      headers: {
        'Content-Type': 'application/json',
      },
      query,
    }).then((res) => {
      if (res.data?.success) {
        setLogJobData(res.data.data)
      }
      setIsLoading(false)
    })
  }

  const onSearch = (query) => {
    getLogJob(query)
  }

  useEffect(
    () => {
      getLogJob()
    },
    [],
  )
  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <PageHeader
          ghost={false}
          title="Log Job"
        >
          <Row gutter={24}>
            <Col xs={24} md={24}>
              <LogJobFilter onSearch={onSearch} />
            </Col>
          </Row>
          <Divider />
          <Table
            dataSource={logJobData}
            size="small"
          >
            <Column title="Id" dataIndex="logJobId" key="logJobId" width={50} sorter={(a, b) => a.logJobId - b.logJobId} sortDirections={['ascend']} />
            <Column title="Function Name" dataIndex="cfgJob" key="cfgJob" width={100} ellipsis render={(text) => (text ? text.funcName : '-')} />
            <Column title="Status" dataIndex="status" key="status" width={50} align="center" render={(text) => (text ? (text === '1' && <Badge status="warning" />) || (text === '2' && <Badge status="success" />) || (text === '0' && <Badge status="error" />) : '-')} />
            <Column title="Message" dataIndex="message" key="message" width={150} ellipsis render={(text) => text || '-'} />
            <Column title="Created At" dataIndex="createdAt" key="createdAt" width={100} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
            <Column title="Updated At" dataIndex="updatedAt" key="updatedAt" width={100} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
          </Table>
        </PageHeader>
      </Spin>
    </>
  )
}

export default LogJob

